import {DatabaseCode, toDatabaseCode} from "./database-code";
import {notificationChannel, NotificationChannel} from "./notification-channel";

export type NotificationReceiverType = DatabaseCode & {
  channel: NotificationChannel
}

const ses: NotificationReceiverType = {
  code: 'SES',
  displayValue: {
    id: 'common.entity.notification.receiver.ses',
    defaultMessage: 'Amazon SES',
  },
  channel: notificationChannel.email,
};

export const notificationReceiverType = {
  ses,
};

export const notificationReceiverTypes = Object.values(notificationReceiverType);

export const toNotificationReceiverType = (code: string): NotificationReceiverType => toDatabaseCode(code, notificationReceiverTypes);
export const toNotificationReceiverTypeSafely = (code: string | undefined): NotificationReceiverType | undefined => code ? toDatabaseCode(code, notificationReceiverTypes) : undefined;
